import { IJoinByInvitation } from '../../../../../../service/invitationLinks/IJoinByInvitation';
import { injectRootService } from '../../../../../../service/RootServiceFactory';
import { IMainLayoutDomainStore } from "../../../../../layout/main/store/domain/IMainLayoutDomainStore";
import { IProjectInvitationJoinDomain } from "./IProjectInvitationJoinDomain";

export class ProjectInvitationJoinDomain implements IProjectInvitationJoinDomain  {
  getInvitationInfo = async (address: string) => this.rootPrivateServices.invitationsLinks.getByAddress(address)

  joinByInvitation = async (payload: IJoinByInvitation) => this.rootPrivateServices.invitationsLinks.joinByInvitation(payload)

  constructor(
        private layoutDomain: IMainLayoutDomainStore,
        public rootPrivateServices = injectRootService(layoutDomain.serviceType.value)
  ) {

  }
}